import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { ImportsModule } from '@mapa/ngx';
import { contactDetails } from '../../public/contact-us/data';
import { PUBLIC_MENU } from '../menu-items';

@Component({
  selector: 'public-sidebar',
  templateUrl: './public-sidebar.component.html',
  styleUrl: './public-sidebar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImportsModule,
    RouterModule
  ],
  host: {
    'class': 'flex flex-col min-h-full'
  }
})
export class PublicSidebarComponent {
  private readonly publicMenu$ = inject(PUBLIC_MENU);

  protected readonly contact = contactDetails;
  protected readonly icons = {
    faInstagram
  } as const;

  protected readonly menuItems$ = computed(() => this.publicMenu$().vertical);

}